import { memoizedGetProjects } from '@/services/project.ts';
import { useAsync } from '@/composables/useAsync.ts';

export function useProjects() {
  const { data: projects, ...rest } = useAsync(memoizedGetProjects, [], {
    immediate: false,
  });

  return { projects, ...rest };
}
